


















import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'

Vue.mixin(ScrollFire)

export default
  components: {
    ReshowQuiz
  }

  props:
    episode:
      type: String
      default: ''
    episode_image:
      type: String
      default: ''
    title:
      type: String
      default: ''
    one_column:
      type: Boolean
      default: false
    mode:
      type: Number
      default: 0
    fire_scroll:
      type: Boolean
      default: false
    quiz_style:
      type: Number
      default: 0
    show_separator:
      type: Boolean
      default: false

  data: () ->
    ext: '_pc.svg'

  created: () ->
    @$options.scroll_target = '.mode' + @mode

  mounted: () ->
    requestAnimationFrame(() =>
      window.addEventListener('resize', @onResize)
    )
    @onResize()

  destroyed: () ->
    window.removeEventListener('resize', @onResize)

  methods: {
    onResize: (e) ->
      if window.innerWidth < 750
        @ext = '_sp.svg'
      else
        @ext = '_pc.svg'
      @$emit('windowResize')
    reshow_quiz: (e) ->
      @$emit('reshow_quiz')
  }
